import axios from './../http'

function query(data) {
    return axios.post('/sys/emailConfig/query', data);
}

function get(id) {
    return axios.get('/sys/emailConfig/get?id=' + id);
}

function add(data) {
    return axios.post('/sys/emailConfig/add', data);
}

function update(data) {
    return axios.post('/sys/emailConfig/update', data);
}

function del(id) {
    return axios.post('/sys/emailConfig/del?id=' + id);
}

export default {
    query,
    get,
    add,
    update,
    del
}